import { IExpressionEvaluator } from "../../../Models/IExpressionEvaluator";
import { IExpressionEvaluatorContext } from "../../../Models/IExpressionEvaluatorContext";
import { MaybePromise } from "../../../Models/MaybePromise";
import { NotifyExpression } from "../../../Models/UserInterfaces/NotifyExpression";
import { NotifyService } from "../../../../UserInterfaceModule/Services/NotifyService";

export class NotifyExpressionEvaluator implements IExpressionEvaluator<NotifyExpression> {
    get type(): string {
        return "UserInterface.Notify";
    }

    evaluate(expression: NotifyExpression, context: IExpressionEvaluatorContext): MaybePromise<void> {
        const notifyService = context.GetProperty<NotifyService>(NotifyService.KEY);
        notifyService.notify(expression.Message, expression.Severity);
    }
}
